import _ from 'lodash';
import React, {cloneElement, useContext, useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer,
  ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import {
  CurrencyAmountRenderer,DateRenderer,DateTimeRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext, IJobListViewContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import ActionButton, {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import {JobNames} from "../../../../framework.core/JobNames";
import {billPaymentList} from "../../tableSettings";
import {BillPaymentListItem} from "../../../../fms.data/models/BillPaymentListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import IfmsModal from "../../../../ui/IfmsModal";
import BankEdi from "./reports/BankEdi";
import BatchCheckProcessing from "./reports/BatchCheckProcessing";
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import { getSelectedSubMenuArgs } from '../../../JobListSubMenu';
import useReportViewer from '../../../../hooks/useReportViewer';
import { FmsSubMenu } from '../../../../constants/fmsSubMenu';
import { DocumentType } from '../../../../framework.core/DocumentType';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import HistoryViewPayment from '../../../reports/HistoryViewPayment';
import { FmsSecTask, BankParams } from '../../../../fms.core/constants';
import CheckPrint from '../../../reports/CheckPrint';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import { useJournal } from '../../general/journal/JournalListView';
import useSuntekSettings from '../../../../hooks/useSuntekSettings';
import useSystemSettings from '../../../../hooks/useSystemSettings';
import { formatDate, nowDate, addDays } from '../../../../dateUtils';
import VendorBalanceDetails from '../../../reports/AccountBalance';
import { SecType } from '../../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../../common/commonExportFormat';
import CheckBoxIcon from '../../../../ui/CheckBoxIcon';
import DateDialog from '../../../common/DateDialog';
import {useTypedFastStorage} from '../../../../hooks/useFastStorage';
import {DepoHd, PaymentGLInfo} from "../../../../fms.core/DepoHd";
import {DepoDetail} from "../../../../fms.core/DepoDetail";
import { useAppSelector } from '../../../../app/hooks';
import { getFmsGlobal } from '../../../../globals';
import {getOriginalValue} from "../../../../fms.core/data/TrackingModule";
import { addBankChargeRow, addOtherBankCharge, getAccumulatedBalance, getRate, saveHistoryHeadData } from '../paymentBase';
import {SQLInfo} from "../../../../framework.core/data/SQLInfo";
import useSetEditedId from "../../../../hooks/useSetEditedId";
import {FormType} from '../../../../fms.enum';
import IconButton, { AddIconButton, AddIconButton2, BalanceIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, PrintIconButton, ViewHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import BatchCheckICon from '../../../../img/BatchCheck.svg';
import BatchCheckICon2 from '../../../../img/BatchCheck2.svg';
import BatchCheckICon_D from '../../../../img/BatchCheck_Dark.svg';
import BatchCheckICon2_D from '../../../../img/BatchCheck_Dark2.svg';
import BPrintICon from '../../../../img/BatchPrint.svg';
import BPrintICon2 from '../../../../img/BatchPrint2.svg';
import BPrintICon2_D from '../../../../img/BatchPrint_Dark2.svg';
import VoidIcon from '../../../../img/BillPay-Void.svg'; 
import VoidIcon2 from '../../../../img/BillPay-Void2.svg'; 
import VoidIcon_D from '../../../../img/BillPay-Void_Dark.svg'; 
import VoidIcon2_D from '../../../../img/BillPay-Void_Dark2.svg'; 
import { SearchModelBase } from '../../../../fms.data/models/SearchModelBase';

const fmsGlobal = getFmsGlobal();

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC') {
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  }

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function VoidDateRenderer({ cell, data, row}:any) {
  const l = data[row.index];
  let dataTooltip = formatDate((l as any).voidDate);

  if (cell && cell.value) {
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={dataTooltip}>
      <CheckBoxIcon value={true} />
    </div>;  
  }

  return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function PrintDateRenderer({ cell, data, row}:any) {
  const l = data[row.index];
  let dataTooltip = formatDate((l as any).chkPrtDate);

  if (cell && cell.value) {
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={dataTooltip}>
      <CheckBoxIcon value={true} />
    </div>;  
  }

  return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function TypeRenderer({ cell ,data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lPayment = (l as any).etfStr as string;
  if (lPayment === 'C') dataTooltip = 'CHECK';
  else if( lPayment === 'W') dataTooltip = 'W/T';
  else if( lPayment === 'A') dataTooltip = 'ACH';
  else if (lPayment === 'O') dataTooltip = 'OTHER';
  else if( lPayment === 'OF') dataTooltip = 'OFFSET';

  return (
    <div  className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ textAlign: 'center'}}>{cell.value}</div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    
  </div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as BillPaymentListItem;
  
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const invSec = findSecurityTask(appContext, FmsSecTask.AcctInvoiceList);
  const gInvSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
  const billSec = findSecurityTask(appContext, FmsSecTask.AcctBillList);
  const gBillSec = findSecurityTask(appContext, FmsSecTask.AcctGBillList);
  const crdbSec = findSecurityTask(appContext, FmsSecTask.AcctCrDbList);

  function OpenNewPageAsync(link:string) {
    openNewPage(history, link, NavigationType.newPage);
    return Promise.resolve(true);
  }

  async function create() {
    // if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acBillPayment/add')) {
    // if (jobListContext.hasOpenedScreenUrl('/accounting/acBillPayment/add')) {
    //   await showGlobalOkDialog(<p>New operation is already in progress</p>);
    //   return;
    // }
    if (selectedElement?.vendorId > 0) {
      openNewPage(history, `/accounting/acBillPayment/add/${selectedElement.vendorId}`, NavigationType.newPage);
    } else {
      openNewPage(history, `/accounting/acBillPayment/add`, NavigationType.newPage);
    }
 }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acBillPayment/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acBillPayment/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill Payment first', false, null, "warning");
      return;
    }

    if (!selectedElement.isDraft) {
      await showGlobalOkDialog('Can delete the Draft Payment', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BillPayment, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message);
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/acBillPayment/edit/${id}`;
    const viewUrl = `/accounting/acBillPayment/view/${id}`;
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/accounting/acBillPayment/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/acBillPayment/edit/${id}`;
    const viewUrl = `/accounting/acBillPayment/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    // if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acBillPayment/add')) {
    if (jobListContext.hasOpenedScreenUrl('/accounting/acBillPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/accounting/acBillPayment/add?copyId=${id}`, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctBPayDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.BillPayment}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function switchToBillings(){
    if (!selectedElement) {
      return;
    }

    let isExistId = false;

    const apiResult = await appContext.api.getRelatedBillingIds(selectedElement.id);
    if(apiResult && apiResult.result){
      const billingids = apiResult.result;     
      let model = new SearchModelBase();

      if(invSec.grantRead && billingids.RelateInvId && billingids.RelateInvId.length > 0){ 
          isExistId = true;
          model.extraWhere = `Id in (${billingids.RelateInvId})`;
          jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting?parentOp=billings',
          '','','Billings','',false,true,model);
          await OpenNewPageAsync('/common/joblistview/invoice/accounting?parentOp=billings');
      } 
      if(billSec.grantRead && billingids.RelateBillId && billingids.RelateBillId.length > 0){ 
        isExistId = true;
        model.extraWhere = `Id in (${billingids.RelateBillId})`;
        jobListContext.setFilterForScreenExternally('/common/joblistview/bill/accounting?parentOp=billings',
        '','','Billings','',false,true,model);
        await OpenNewPageAsync('/common/joblistview/bill/accounting?parentOp=billings');
      }
      
      if(crdbSec.grantRead && billingids.RelateCrDbId && billingids.RelateCrDbId.length > 0){ 
        isExistId = true;
        model.extraWhere = `Id in (${billingids.RelateCrDbId})`;
        jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting?parentOp=billings',
        '','','Billings','',false,true,model);
        await OpenNewPageAsync('/common/joblistview/crdb/accounting?parentOp=billings');
      }
      
      if(gInvSec.grantRead && billingids.RelateGInvId && billingids.RelateGInvId.length > 0){
        isExistId = true;
        model.extraWhere = `Id in (${billingids.RelateGInvId})`;
        jobListContext.setFilterForScreenExternally('/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
        '','','Billings','',false,true,model);
        await OpenNewPageAsync('/common/joblistview/acGeneralInvoice/accounting?parentOp=billings');
      }

      if(gBillSec.grantRead && billingids.RelateGBillId && billingids.RelateGBillId.length > 0){ 
        isExistId = true;
        model.extraWhere = `Id in (${billingids.RelateGBillId})`;
        jobListContext.setFilterForScreenExternally('/common/joblistview/acGeneralBill/accounting?parentOp=billings',
        '','','Billings','',false,true,model);
        await OpenNewPageAsync('/common/joblistview/acGeneralBill/accounting?parentOp=billings');
      }
    } 

    if(!isExistId){
      await showGlobalOkDialog("Can not go to Billings List.");
    }
  }



  return {create, deleteItem: deleteItem, edit, view, copy, moveToDeleteHistoryReport, switchToBillings};
}

function useSelectedVoid({ paymentRef }: { paymentRef: React.MutableRefObject<DepoHd> }) {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as BillPaymentListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const userState = useAppSelector(state => state.user);
  const mnuCheckM = userState.user?.isSuntekAdmin ? true : appContext.securityGrants?.find(x=>x.securityTaskCode === FmsSecTask.ToolBlock)?.grantRead ?? false;
  const suntekSettings = useSuntekSettings();
  const systemSettings = useSystemSettings();
  const primaryCurrency = systemSettings?.primaryCurrency??'USD';

  const setSavedEntity = useSetEditedId([JobNames.BillPayment]);
  const setSavedEntityInvo = useSetEditedId([JobNames.Invoice, JobNames.OpInvoice]);
  const setSavedEntityBill = useSetEditedId([JobNames.Bill, JobNames.OpBill]);
  const setSavedEntityCrDb = useSetEditedId([JobNames.CrDb, JobNames.OpCrDb]);
  const setSavedEntityGInvo = useSetEditedId([JobNames.GInvo]);
  const setSavedEntityGBill = useSetEditedId([JobNames.GBill]);
  const setSavedEntityPayrollOld = useSetEditedId([JobNames.PayrollSummary]);
  const setSavedEntityPayroll = useSetEditedId([JobNames.Payroll2]);
  const setSavedEntityTaxReturn = useSetEditedId([JobNames.SalesTaxReturn]);
  const setSavedEntityCCPay = useSetEditedId([JobNames.CCPayment]);

  function setDepoDetailData(detail: DepoDetail, payment:DepoHd){
    let bIsPayable;
    switch (detail.tbName.toUpperCase())
    {
      case "T_INVOHD":
        bIsPayable = true;
        break;
      case "T_APHD":
        bIsPayable = false;
        break;
      case "T_CRDBHD":
        bIsPayable = true;
        break;
      case "T_PAYROLL":
      case "T_PAYROLL2PAY":
        bIsPayable = false;
        break;
      case "T_DEPOHD":
        bIsPayable = false;
        break;
      case "T_TAXRTN":
        bIsPayable = (detail.payType === "TR");
        break;
      default:
        if(detail.glNo === fmsGlobal.AdvPayGLNo){
          bIsPayable = false;
        }else{
          bIsPayable = true;
        }
        break;
    }
    detail.branch = detail.branch ? detail.branch : appContext.user?.branch??'';
    detail.stbName = detail.stbName === "GEN" ? "OTH" : detail.stbName;
  
    if (suntekSettings?.accounting?.useOtherRefNoInsteadOfBLNo){   
      detail.hblNo = detail.sRefNo;
    }
    
    detail.dueAmount = detail.invAmount - detail.paidAmount;
    if(bIsPayable){
      detail.invAmount = -detail.invAmount;
      detail.dueAmount = -detail.dueAmount;
      detail.paidAmount = -detail.paidAmount;
    }
    detail.paidAmount = detail.paidAmount - detail.amount;
    detail.isSelect = true;
  
    if(detail.tbName){
      detail.glDescription = detail.glDescription2;
    }
  
    if(detail.glNo === suntekSettings.accounting?.bankChargeAccountCode){   
      detail.glDescription = detail.description;
    }
    
    if(detail.othInvNo.length !== 0){
      detail.postDate = payment.postDate;
      detail.entity = payment.billTo;
      detail.entityName = payment.billToName;
      detail.invNo = detail.othInvNo;
      detail.hblNo = detail.othRefNo;
      detail.isInsertRow = true;
    }
    return detail;
  }

  function setRelatedAccountEntity(detail: DepoDetail) {
    switch (detail.tbName) {
      case "T_INVOHD":
        if (detail.stbName) setSavedEntityInvo(detail.tbId.toString(), detail.id <= 0, false)
        else setSavedEntityGInvo(detail.tbId.toString(), detail.id <= 0, false)
        break;
      case "T_APHD":
        if (detail.stbName) setSavedEntityBill(detail.tbId.toString(), detail.id <= 0, false)
        else setSavedEntityGBill(detail.tbId.toString(), detail.id <= 0, false)
        break;
      case "T_CRDBHD":
        setSavedEntityCrDb(detail.tbId.toString(), detail.id <= 0, false)
        break;
      case "T_PAYROLL":
        setSavedEntityPayrollOld(detail.mblId.toString(), detail.id <= 0, false);
        break;
      case "T_PAYROLL2PAY":
        setSavedEntityPayroll(detail.mblId.toString(), detail.id <= 0, false)
        break;
      case "T_TAXRTN":
        setSavedEntityTaxReturn(detail.tbId.toString(), detail.id <= 0, false)
        break;
      case "T_DEPOHD":
        setSavedEntityCCPay(detail.tbId.toString(), detail.id <= 0, false)
        break;
    }
  }

  async function loadExistingDepoDetail(id: number) {
    const apiResult = await appContext.api.getJobDetail(JobNames.BillPayment, {id, isCopy: false});

    const fileClose = await appContext.api.CheckCloseDateNew(JobNames.BillPayment, apiResult.result.postDate );
    if(fileClose > 0){
      apiResult.result.hdIsClosed = true;
    }

    const payment: DepoHd = apiResult.result;
    const model = new DepoHd(_.cloneDeep(payment))

    await readDepoDetailData(model);
    paymentRef.current = new DepoHd(model);

    await readAccountData();
  }

  async function readDepoDetailData(payment: DepoHd){
    payment.isAll= true;
    payment.isAR= true;
    payment.isAP= true;
    payment.isARAgent= true;
    payment.isAPAgent= true;
    payment.isReceivable= true;
    payment.isPayable= true;
    payment.isCrDbConfrimed= false;
    payment.type = "C";
    payment.isBlockVisible = mnuCheckM;
    payment.oldPostDate = payment.postDate;

    payment.depoDetails.forEach(detail => {
      if(detail.tbName.length > 0 || (detail.glNo === suntekSettings.accounting?.bankChargeAccountCode && !detail.payType.length) || (detail.othInvNo.length !== 0 && detail.payType !== 'OT')){
        payment.acctList.push(setDepoDetailData(detail, payment));
  
        if(payment.billTo !== detail.entity){  
          payment.bConfirmMsg = false;
        }
        
      }else if([fmsGlobal.AdvRecGLNo, fmsGlobal.AdvPayGLNo].includes(detail.glNo)) {
        payment.advDetailList.push(detail);
      }else{
        detail.branch = detail.branch ? detail.branch : appContext.user?.branch??'';

        payment.otherList.push(detail);
      }
    });

    const advRcvds = payment.advDetailList.filter(x=>x.glNo === fmsGlobal.AdvRecGLNo);
    const advPymts = payment.advDetailList.filter(x=>x.glNo === fmsGlobal.AdvPayGLNo);

    payment.advRcvPaid = advRcvds.reduce((sum: number, x) => sum + x.amount, 0);
    payment.advPayPaid = advPymts.reduce((sum: number, x) => sum + x.amount, 0);
  
    payment.advRcvDecAmt = advRcvds.filter(x=>x.amount > 0).reduce((sum: number, x) => sum + x.amount, 0)
      -advRcvds.filter(x=>x.amount <= 0).reduce((sum: number, x) => sum + x.amount, 0)
    payment.advRcvIncAmt = 0;
    payment.advRcvLAmount = advRcvds.reduce((sum: number, x) => sum + x.lAmount, 0);
    payment.advRcvOAmount = advRcvds.reduce((sum: number, x) => sum + x.oAmount, 0);
  
    payment.advPayDecAmt = -advPymts.filter(x=>x.amount <= 0).reduce((sum: number, x) => sum + x.amount, 0);
    payment.advPayIncAmt = advPymts.filter(x=>x.amount > 0).reduce((sum: number, x) => sum + x.amount, 0);
    payment.advPayLAmount = advPymts.reduce((sum: number, x) => sum + x.lAmount, 0);
    payment.advPayOAmount = advPymts.reduce((sum: number, x) => sum + x.oAmount, 0);
  
    if(advRcvds.length > 0){
      payment.advList.push(new DepoDetail({
        branch: advRcvds[0].branch,
        glNo: advRcvds[0].glNo,
        glDescription: advRcvds[0].glDescription,
        currency: advRcvds[0].currency,
        balance: 0,
        increase: payment.advRcvIncAmt,
        decrease: payment.advRcvDecAmt,
        lAmount: payment.advRcvLAmount,
        oAmount: payment.advRcvOAmount,
        exrateO: advRcvds[0].exrateO,
        flAmount: payment.advRcvLAmount,
        foAmount: payment.advRcvOAmount,
        histID: advRcvds.some(x=>x.histID > 0) ? advRcvds.find(x=>x.histID > 0)?.histID : 0,
        id: advRcvds[0].id,
        depoHdId: payment.id
      }));
    }
  
    if(advPymts.length > 0){
      payment.advList.push(new DepoDetail({
        branch: advPymts[0].branch,
        glNo: advPymts[0].glNo,
        glDescription: advPymts[0].glDescription,
        currency: advPymts[0].currency,
        balance: 0,
        increase: payment.advPayIncAmt,
        decrease: payment.advPayDecAmt,
        lAmount: payment.advPayLAmount,
        oAmount: payment.advPayOAmount,
        exrateO: advPymts[0].exrateO,
        flAmount: payment.advPayLAmount,
        foAmount: payment.advPayOAmount,
        histID: advPymts.some(x=>x.histID > 0) ? advPymts.find(x=>x.histID > 0)?.histID : 0,
        id: advPymts[0].id,
        depoHdId: payment.id
      }));
    }
    payment.otherList.sort((a, b) => a.sortNo - b.sortNo);

    if (payment.isDraft) {
      const detail = await addBankChargeRow(payment, appContext);
      if (detail) {
        payment.acctList.unshift(detail);
      }
    }
  }

  async function readAccountData() {
    const payment = paymentRef.current;
    if (!payment) return;

    await getRate(payment, appContext);
    await readAccountCode();
  }

  async function readAccountCode(addNonOpTabData:boolean = false){
    const payment = paymentRef.current;
    if(!payment) return;
    
    try{
      if(payment.billTo > 0){
        const apiResult = await appContext.api.getBalanceForAccountCode(JobNames.BillPayment, payment.id, payment.billTo, payment.currency);
        if(!apiResult || !apiResult.success){
          return;
        }
        
        const advanceAcctInfos = apiResult.result as PaymentGLInfo[];
        payment.paymentGlInfo = advanceAcctInfos;

        payment.initAdvRcvdBalance = advanceAcctInfos.filter(x => x.glNo === fmsGlobal.AdvRecGLNo).reduce((sum: number, x) => sum + x.balance, 0);
        payment.initAdvPymtBalance = advanceAcctInfos.filter(x => x.glNo === fmsGlobal.AdvPayGLNo).reduce((sum: number, x) => sum + x.balance, 0);
        // <chuck date="2025-09-12" desc="자기 자신은 초기 Balance에서 제외한다. 기존엔 쿼리에서 처리되었으나 로직 변경으로 여기서 처리">
        payment.initAdvRcvdBalance += payment.advRcvPaid;
        payment.initAdvPymtBalance -= payment.advPayPaid;
        // </chuck>

        payment.isNonOPBalance = false;
        if (payment.paymentGlInfo.filter(x => x.glNo !== fmsGlobal.AdvPayGLNo && x.glNo !== fmsGlobal.AdvRecGLNo).find(x => x.balance !== 0)) {
          payment.isNonOPBalance = payment.otherList.some(x => payment.paymentGlInfo.filter(y => y.balance !== 0).map(y => y.glNo).includes(x.glNo));
        }

        [fmsGlobal.AdvPayGLNo, fmsGlobal.AdvRecGLNo].forEach(sGLNo =>{
          if(payment.advList.some(x=>x.glNo === sGLNo)){
            payment.advList.filter(x=>x.glNo === sGLNo)[0].balance = sGLNo === fmsGlobal.AdvRecGLNo? payment.initAdvRcvdBalance : payment.initAdvPymtBalance;
          }else{
            const detail = new DepoDetail({
              currency: payment.currency,
              glNo: sGLNo,
              glDescription: sGLNo === fmsGlobal.AdvRecGLNo ? "ADVANCE RECEIVED" : "ADVANCE PAYMENT",
              description: sGLNo === fmsGlobal.AdvRecGLNo ? "ADVANCE RECEIVED" : "ADVANCE PAYMENT",
              increase: 0,
              decrease: 0,
              balance: sGLNo === fmsGlobal.AdvRecGLNo? payment.initAdvRcvdBalance : payment.initAdvPymtBalance,
              payType: "OT",
              id: payment.GetNextId(),
              depoHdId: payment.id,
              trackable: true
            });
            payment.advList.push(detail);
          }
        });

        payment.advList.forEach(adv =>{
          let paid: number = 0;
          let initBalnce = fmsGlobal.AdvPayGLNo === adv.glNo ? payment.initAdvPymtBalance : payment.initAdvRcvdBalance;
          paid = adv.increase;
          paid = paid - adv.decrease;

          if(!payment.isVoid){
            adv.balance = initBalnce + paid;
          }
        });

        payment.advList = payment.advList.sort((a, b) => parseInt(a.glNo) - parseInt(b.glNo));

        if (addNonOpTabData) {


          if (primaryCurrency === payment.currency) {
            payment.otherList.forEach(f => f.isInsertRow = true);

            for (let index = 0; index < payment.paymentGlInfo.length; index++) {
              const glInfo = payment.paymentGlInfo[index];
              if (glInfo.glNo === fmsGlobal.AdvPayGLNo || glInfo.glNo === fmsGlobal.AdvRecGLNo) continue;
              
              const findOther = payment.otherList.find(x => x.glNo === glInfo.glNo);
              if (findOther != null) {
                if (glInfo.isDefault === 1) findOther.isInsertRow = false;
                findOther.balance = glInfo.balance;
              }
              else {
                const other = new DepoDetail({
                  branch: "",
                  othInvNo: "",
                  glNo: glInfo.glNo,
                  // <chuck date="2025-08-25" tag="Change Non-OP" desc="GLDesc도 저장해야 해서 OthRefNo 필드를 사용함" />
                  //glDescription: glInfo.glDesc,
                  othRefNo: glInfo.glDesc,
                  description: "",
                  currency: primaryCurrency,
                  balance: glInfo.balance,
                  newBalance: 0,
                  sortNo: Number('2'+ glInfo.glNo),
                  isInsertRow: false,
                  depoHdId: payment.id,
                });
                payment.otherList.push(other);
              }
            }
            payment.otherList.sort((a, b) => a.sortNo - b.sortNo);
          }

          if (payment.etf === 1) {
            const detail = await addOtherBankCharge(payment, appContext);
            if (detail) {
              payment.otherList.unshift(detail);
            }
          }
          paymentRef.current.otherList = payment.otherList;
        }
        else {
          if (primaryCurrency === payment.currency) {
            for (let index = 0; index < payment.paymentGlInfo.length; index++) {
              const glInfo = payment.paymentGlInfo[index];
              if (glInfo.glNo === fmsGlobal.AdvPayGLNo || glInfo.glNo === fmsGlobal.AdvRecGLNo) continue;
              
              const findOther = payment.otherList.find(x => x.glNo === glInfo.glNo);
              if (findOther != null) {
                if (glInfo.isDefault === 1) findOther.isInsertRow = false;
                findOther.balance = glInfo.balance;
              }
            }
            payment.otherList.sort((a, b) => a.sortNo - b.sortNo);
          }
          paymentRef.current.otherList = payment.otherList;
        }
      }
    } catch (e) {
      await showGlobalOkDialog(<p>Account Code Read Error !!</p>);
    }
  }

  return {setSavedEntity, setRelatedAccountEntity, loadExistingDepoDetail};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, switchToBillings } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);

  const selectedElement = jobListContext.selectedElement as BillPaymentListItem;

  async function openVoid() {
    if (jobListContext.rowExtrasId) {
      return; 
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Void', shortcut: '', separator: !listSec?.grantDel },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: !jobListContext.selectedElement.isDraft },
    { label: 'Go to Billings List', shortcut:'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="billPayment-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        openVoid();
        break;
      case 4:
        // deleteItem();
        view();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToBillings();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as BillPaymentListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);
  
  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@')) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.BillPayment, selectedElement.id, "", null, selectedElement.checkNo)} useText/>
  // );
  return null;
}

function ListCommands({ paymentRef }: { paymentRef: React.MutableRefObject<DepoHd> }) {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as BillPaymentListItem;

  const {create, deleteItem, edit, view, moveToDeleteHistoryReport, /*copy*/} = useSelectedOperations();
  const {setSavedEntity, setRelatedAccountEntity, loadExistingDepoDetail} = useSelectedVoid({ paymentRef });
  const {switchJournal} = useJournal();

  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showVoidDialog, setShowVoidDialog] = useState(false);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const bPrintLabel = appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'B.Check Print' : 'Batch Check Print';
  const batchLabel = appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'B.Check Processing' : 'Batch Check Processing';
  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acBillPayment/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acBillPayment/view/${id}`);
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);
  const readSecDelHistory = getSecBySecTask(appContext, FmsSecTask.AcctBPayDeleteHistory, SecType.Read);
  const userId = appContext.user?.id ?? '';

  const suntekSettings = useSuntekSettings();

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  // const canBeAdd = listSec?.grantAdd && !jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acBillPayment/add');;
  const canBeAdd = listSec?.grantAdd && !jobListContext.hasOpenedScreenUrl('/accounting/acBillPayment/add');;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);

  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@');

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
  
  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.BillPayment, selectedElement, appContext, null, null);
    if(args){
      viewReport(args, "", true);
    }
  }

  async function vendorBalance() {
    if (selectedElement.vendorId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Vendor.</p>, false, null, 'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <VendorBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.BillPayment}
          onPopupClose={onPopupClose}
          toDate={selectedElement.postDate??nowDate()}
          comId={selectedElement.vendorId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.firstVendor}
        />
    })
  }
  
  async function voidCheckData() {
    if (await appContext.api.existCreditItem(selectedElement.id)) {
      await showGlobalOkDialog(<p>Cannot void due to Give/Receive Credit.<br/>Please cancel Give/Receive Credit First.</p>, false, null, "info");
      return;
    }
    
    const taxReturnCheck = await appContext.api.taxReturnCheck(JobNames.BillPayment, selectedElement.id);

    if (taxReturnCheck) {
      await showGlobalOkDialog(<p>Cannot void this record because it contains items used in the Sales Tax Return.</p>, false, null, 'warning');
      return;
    }

    if (selectedElement.void) {
      await showGlobalOkDialog(<p>It's already voided.</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.isDraft) {
      await showGlobalOkDialog(<p>Cannot void the Draft Payment</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.status) {
      await showGlobalOkDialog(<p>Cannot void this record because it was closed.</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.depositDate) {
      await showGlobalOkDialog(<p>Cannot void this record because it was deposited.</p>, false, null, 'warning');
      return;
    }

    await loadExistingDepoDetail(selectedElement.id);

    const payment = paymentRef.current;
    if (!payment) return;

    // 기존 코드로 동작시 ErrMsg 뜨고 VoidPopup도 뜨는 문제 있어 주석 처리
    // payment.advList.forEach(async adv =>{
    //   if (adv.increase > 0) {
    //     const originDate: string = getOriginalValue(payment, "postDate");
    //     const errMsg = await getAccumulatedBalance(payment, originDate, 0, adv.glNo, 2, appContext)
    //     if (errMsg) {
    //       await showGlobalOkDialog(<p>{errMsg}</p>, false, null, "error");
    //       return;
    //     }
    //   }
    // });

    for (const adv of payment.advList){
      if (adv.increase > 0) {
        const originDate: string = getOriginalValue(payment, "postDate");
        const errMsg = await getAccumulatedBalance(payment, originDate, 0, adv.glNo, 2, appContext)
        if (errMsg) {
          await showGlobalOkDialog(<p>{errMsg}</p>, false, null, "warning");
          return;
        }
      }
    }

    const closeDate = suntekSettings.myCompany?.closeDate?? nowDate();
    if (payment.isDraft || payment.etf === 1) {
      const doNo = await showGlobalYesNoDialog(
        <div>
          <p>Do you confirm to Void Bill Pay?</p>
        </div>
      , false, 0, true, 'warning');
      
      if (!doNo) {
        return;
      }
      const inputDate = payment.hdIsClosed ? addDays(closeDate, 1) : payment.postDate;  
      voidAction(inputDate, 8);
    } else {
      payment.defaultVoidDate = payment.hdIsClosed ? addDays(closeDate, 1) : payment.postDate;
      //setShowVoidDialog(true);
      setSelectedPopupMenuItem({ label: 'Void', popupWidth: 440, popupComponent: <DateDialog dateLabel="Void Date" initDate={payment.defaultVoidDate} onOk={inputDate => {return voidAction(inputDate, 6)}} onCancel={onPopupClose} /> })
    }

  }

  async function voidAction(inputDate: string | null, actionType: number) {
    if (!inputDate) return;

    const paymentDetail = paymentRef.current;
    if (!paymentDetail) return;

    if (paymentDetail.isDraft) {
      paymentDetail.defaultVoidDate = nowDate();
      inputDate = nowDate();
    }

    // 1. Validation Check & Void/NSF
    let apiResult = await appContext.api.setVoidFieldByDepoData(paymentDetail.id, actionType, inputDate, paymentDetail.defaultVoidDate, paymentDetail.u2Date, false, true, !paymentDetail.isDraft, paymentDetail.type, "", "", "", "", "", "", "", paymentDetail.acctList);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return paymentDetail.defaultVoidDate;
    }
    
    // 2. Add History
    const sqlInfoList: SQLInfo[] = [];
    saveHistoryHeadData(sqlInfoList, paymentDetail, "Void", FormType.ModeEdit, appContext.user?.id??"");

    // 3. Update Payment
    apiResult = await appContext.api.updatePayment(sqlInfoList);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return paymentDetail.defaultVoidDate;
    } 

    setSelectedPopupMenuItem(null);

    // 4. List Update
    setSavedEntity(paymentDetail.id.toString(), false);
    paymentDetail.acctList.forEach(d=>{
      setRelatedAccountEntity(d);
    });
  }

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <AddIconButton2 name='billPayment-list-add-button' disabled={!canBeAdd} onClick={create} useText iconMode />
        <EditIconButton2 name='billPayment-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='billPayment-list-view-button' disabled={!hasSelectedRow} onClick={view} useText  />
        <DeleteIconButton2 name='billPayment-list-delete-button' disabled={!canBeDeleted} onClick={view} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <ViewHistoryIconButton name='billPayment-list-history-button' disabled={!hasSelectedRow}
          onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1240, popupComponent: <HistoryViewPayment jobId={selectedElement.id} jobType={FmsSubMenu.BPHistory} /> })} useText />
        <DeleteHistoryIconButton name='billPayment-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} disabled={false} useText />
        {hasSecBal && (<BalanceIconButton name='billPayment-list-balance-button' disabled={!hasSelectedRow} onClick={vendorBalance} useText />)}
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <IconButton data-tooltip='Void' name='billPayment-list-void-button' disabled={!hasSelectedRow} onClick={voidCheckData} icon={appContext.useDarkMode ? VoidIcon2_D : VoidIcon2} useText />
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrintIconButton name='billPayment-list-printCheck-button'
          onClick={() => {
            if (selectedElement.void) {
              showGlobalOkDialog(<p>Void Payment can't print checks.</p>);
              return;
            }
            if (selectedElement.isDraft) {
              showGlobalOkDialog(<p>Draft Payment can't print checks.</p>);
              return;
            }
            const data = { id: selectedElement.id, bankId: selectedElement.bankId, checkNo: selectedElement.checkNo };
            setSelectedPopupMenuItem({ label: 'Print Check', popupWidth: 450, popupComponent: <CheckPrint checkRange={false} selectedElement={data} documentType={DocumentType.Check} batchCheck={false} /> });
          }} disabled={false} useText />
        {/* 250722.inhyung.issue#2557 Type에 따른 icon text 변경 */}
        <IconButton
        data-tooltip={bPrintLabel}
        name='billPayment-list-batchPrint-button'
        onClick={() => {
          const data = {
            id: selectedElement.id,
            bankId: selectedElement.bankId,
            checkNo: selectedElement.checkNo
          };
          setSelectedPopupMenuItem({
            label: "Batch Check Print",
            popupWidth: 450,
            popupComponent: (
              <CheckPrint
                checkRange={true}
                selectedElement={data}
                documentType={DocumentType.CheckS}
                batchCheck={false}
                draftOrVoid={selectedElement.isDraft || selectedElement.void}
              />
            )
          });
        }}
        icon={appContext.useDarkMode ? BPrintICon2_D : BPrintICon2}
        useText
      >

      </IconButton>
        <IconButton 
        data-tooltip={batchLabel}
        name='billPayment-list-batchCheck-button' 
        onClick={() => {
          setSelectedPopupMenuItem({
            label: 'Batch Check Processing',
            popupComponent: <BatchCheckProcessing jobName={JobNames.BillPayment} selectedElementId={selectedElement?.id} reload={() => jobListContext.reloadData()} />
          })
        }} icon={appContext.useDarkMode ? BatchCheckICon2_D : BatchCheckICon2} useText />
      </div>
      {/* <ActionButton
        type="iconButton"
        tooltip='More Menu'
        variant='plain'
        useInList
        onItemSelected={(event) => setSelectedPopupMenuItem(event)}
        items={[
          { label: 'Bank EDI (ARP)', separator: false, popupComponent: <BankEdi jobName={JobNames.BillPayment} selectedElementId={selectedElement?.id} /> },
          // {label: 'Batch Check Processing', separator: false, popupComponent: <BatchCheckProcessing jobName={JobNames.BillPayment} selectedElementId={selectedElement?.id} />,},
          { label: 'Print Check Attachment', separator: false, subMenu: FmsSubMenu.PrintCheckSlip },
          { label: 'Print Messenger Slip', separator: false, subMenu: FmsSubMenu.PrintMessengerSlip },
        ]}
      >
        <img src={MoreMenuICon} alt="" />
      </ActionButton>&nbsp; */}
      {!checkSecJournal &&  <JournalIconButton onClick={()=> switchJournal(JobNames.BillPayment, selectedElement.id, "", null, selectedElement.checkNo)} useText/>}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);

  const history = useHistory();

  const {create, edit, view, switchToBillings} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F6") {
      switchToBillings();
    }
    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'F3', 'F9', 'F11', 'F8', 'F6'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }


  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.BillPayment}
      //entityId={(jobListContext.selectedElement as BillPaymentListItem | null)?.id}
      jobId={(jobListContext.selectedElement as BillPaymentListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function ListRowExtras ({ rowId, context, paymentRef }: { rowId: number | null; context: IJobListViewContext; paymentRef: React.MutableRefObject<DepoHd> }) {

  const {setSavedEntity, setRelatedAccountEntity, loadExistingDepoDetail} = useSelectedVoid({ paymentRef });

  const suntekSettings = useSuntekSettings();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const selectedElement = jobListContext.selectedElement as BillPaymentListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [selectedPayment, setSelectedPayment] = useState<DepoHd | null>(null);
  const [isVoidCheck,setIsVoidCheck] = useState<boolean>(false);

  function onClose() {
    context.setRowExtrasId(null);
    setIsVoidCheck(false);
  }

  useEffect(() => {
    async function voidCheck(){
      await voidCheckData();
    }
    if (rowId && selectedElement){
      if (rowId == selectedElement.id) {
        voidCheck();
      }
      else {
        context.setRowExtrasId(null);
      }
    }
  }, [rowId, selectedElement]);

  if (!rowId) {
    return null;
  } 

  async function voidCheckData() {
    if (!rowId) {
      return null;
    } 

    if (await appContext.api.existCreditItem(selectedElement.id)) {
      await showGlobalOkDialog(<p>Cannot void due to Give/Receive Credit.<br/>Please cancel Give/Receive Credit First.</p>, false, null, "info");
      return;
    }

    const taxReturnCheck = await appContext.api.taxReturnCheck(JobNames.BillPayment, selectedElement.id);

    if (taxReturnCheck) {
      await showGlobalOkDialog(<p>Cannot void this record because it contains items used in the Sales Tax Return.</p>, false, null, 'warning');
      return;
    }

    if (selectedElement.void) {
      await showGlobalOkDialog(<p>It's already voided.</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.isDraft) {
      await showGlobalOkDialog(<p>Cannot void the Draft Payment</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.status) {
      await showGlobalOkDialog(<p>Cannot void this record because it was closed.</p>, false, null, 'warning');
      return;
    }
    else if (selectedElement.depositDate) {
      await showGlobalOkDialog(<p>Cannot void this record because it was deposited.</p>, false, null, 'warning');
      return;
    }

    await loadExistingDepoDetail(rowId);

    const payment = paymentRef.current;
    if (!payment || payment.id !== selectedElement.id) return;

    
    // 기존 코드로 동작시 ErrMsg 뜨고 VoidPopup도 뜨는 문제 있어 주석 처리
    // payment.advList.forEach(async adv =>{
    //   if (adv.increase > 0) {
    //     const originDate: string = getOriginalValue(payment, "postDate");
    //     const errMsg = await getAccumulatedBalance(payment, originDate, 0, adv.glNo, 2, appContext)
    //     if (errMsg) {
    //       await showGlobalOkDialog(<p>{errMsg}</p>, false, null, "info");
    //       return;
    //     }
    //   }
    // });

    for (const adv of payment.advList){
      if (adv.increase > 0) {
        const originDate: string = getOriginalValue(payment, "postDate");
        const errMsg = await getAccumulatedBalance(payment, originDate, 0, adv.glNo, 2, appContext)
        if (errMsg) {
          await showGlobalOkDialog(<p>{errMsg}</p>, false, null, "warning");
          return;
        }
      }
    }

    // [TEST] Non-Operating 음수 입력이 가능해지면서 유효성 검사 제거
    // payment.otherList.forEach(async other => {
    //   if (other.amount > 0) {
    //     const originDate: string = getOriginalValue(payment, "postDate");
    //     const errMsg = await getAccumulatedBalance(payment, originDate, 0, other.glNo, 2, appContext);
    //     if (errMsg) {
    //       await showGlobalOkDialog(<p>{errMsg}</p>, false, null, "info");
    //       return;
    //     }
    //   }
    // });

    const closeDate = suntekSettings.myCompany?.closeDate?? nowDate();
    if (payment.isDraft || payment.etf === 1) {
      const doNo = await showGlobalYesNoDialog(
        <div>
          <p>Do you confirm to Void Bill Pay?</p>
        </div>
      , false, 0, true, 'warning');
      
      if (!doNo) {
        return;
      }
      const inputDate = payment.hdIsClosed ? addDays(closeDate, 1) : payment.postDate;
      voidAction(payment, inputDate, 8);
    } else {
      payment.defaultVoidDate = payment.hdIsClosed ? addDays(closeDate, 1) : payment.postDate;
      paymentRef.current.defaultVoidDate = payment.defaultVoidDate;
      setSelectedPayment(new DepoHd(payment));
      setIsVoidCheck(true);
    }
  }

  async function voidAction(payment: DepoHd, inputDate: string | null, actionType: number) {
    if (!inputDate) return;

    const paymentDetail = { ...payment };
    if (!paymentDetail) return;

    if (paymentDetail.isDraft) {
      paymentDetail.defaultVoidDate = nowDate();
      inputDate = nowDate();
    }

    // 1. Validation Check & Void/NSF
    let apiResult = await appContext.api.setVoidFieldByDepoData(paymentDetail.id, actionType, inputDate, paymentDetail.defaultVoidDate, paymentDetail.u2Date, false, true, !paymentDetail.isDraft, paymentDetail.type, "", "", "", "", "", "","", paymentDetail.acctList);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return paymentDetail.defaultVoidDate;
    }
    
    // 2. Add History
    const sqlInfoList: SQLInfo[] = [];
    saveHistoryHeadData(sqlInfoList, new DepoHd(paymentDetail), "Void", FormType.ModeEdit, appContext.user?.id??"");

    // 3. Update Payment
    apiResult = await appContext.api.updatePayment(sqlInfoList);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return paymentDetail.defaultVoidDate;
    } 

    context.setRowExtrasId(null);

    // 4. List Update
    setSavedEntity(paymentDetail.id.toString(), false);
    paymentDetail.acctList.forEach(d=>{
      setRelatedAccountEntity(d);
    });
  }

  if(isVoidCheck && selectedPayment){
    return (
      <IfmsModal isBlueHeader onCancel={onClose} draggable isOpen title="Void" width="440px">
        <DateDialog dateLabel="Void Date" initDate={selectedPayment.defaultVoidDate??''} onOk={inputDate => {return voidAction(selectedPayment!, inputDate, 6)}} onCancel={onClose} />
      </IfmsModal>
     );
  } 

  return null;
}

/**
 * Concrete implementation for Customer Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  paymentRef = { current: new DepoHd() } as React.MutableRefObject<DepoHd>;

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.BillPayment,
      'BillPaymentListItem',
      BillPaymentListItem.calculateSearchParameters(search, BillPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: BillPaymentListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.BillPayment, 'BillPaymentListItem',
      BillPaymentListItem.calculateSearchParameters(search, BillPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  BillPaymentListItem.formatData(apiResult.entities);
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'isDraft', Cell: NullableCheckboxIconRenderer},
      {accessor: 'void', Cell: VoidDateRenderer, Header: () => <div data-tooltip="Void">Void</div>},
      {accessor: 'chkPrint', Cell: PrintDateRenderer},
      {accessor: 'block', Cell: NullableCheckboxIconRenderer},
      {accessor: 'vendor', Cell: TextAlignLeftRenderer},
      {accessor: 'paidTo', Cell: TextAlignLeftRenderer},
      {accessor: 'etfStr', Cell: TypeRenderer},
      {accessor: 'checkNo', Cell: TextAlignLeftRenderer},
      {accessor: 'bankName', Cell: TextAlignLeftRenderer},
      {accessor: 'currency', Cell: TextRenderer},
      {accessor: 'totalAmt', Cell: (props:any) => <CurrencyAmountRenderer currencyAccessor={(x:any) => x.currency} {...props} />},
      {accessor: 'invoiceNo', Cell: TextAlignLeftRenderer},
      {accessor: 'remark', Cell: TextAlignLeftRenderer},
      {accessor: 'postDate', Cell: DateRenderer},
      {accessor: 'depositDate', Cell: DateRenderer},
      // {accessor: 'voidDate', Cell: VoidDateRenderer},
      {accessor: 'u1Date', Cell: DateTimeRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
    ];
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'isDraft', changedValue: (value: any) => { return nullableCheckBoxValue(value['isDraft'])} });
    colRenderer.push({ accessor: 'block', changedValue: (value: any) => { return nullableCheckBoxValue(value['block'])} });
    colRenderer.push({ accessor: 'chkPrint', changedValue: (value: any) => { return nullableCheckBoxValue(value['chkPrint'])} });
    colRenderer.push({ accessor: 'void', changedValue: (value: any) => { return nullableCheckBoxValue(value['void'])} });
    colRenderer.push({ accessor: 'totalAmt', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['totalAmt']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  billPaymentList;
    const cols = BillPaymentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands paymentRef={this.paymentRef}/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode|null {
    return <ListRowExtras rowId={rowId} context={context} paymentRef={this.paymentRef} />
  }

  getViewUrlFor(row: BillPaymentListItem) {
    return row && row.id ? `/accounting/acBillPayment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Bill Pay List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.BillPayment} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
